export const Colors = {
  darkGreen: '#002f37',
  riseGreen: '#00a824',
  fallRed: '#D90707',
  offWhite: '#E0E0E0',
  orange: '#F05825E6',
};
